import { render, staticRenderFns } from "./ReservationsLuuma.vue?vue&type=template&id=1e34168c&scoped=true"
import script from "./ReservationsLuuma.vue?vue&type=script&lang=js"
export * from "./ReservationsLuuma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e34168c",
  null
  
)

export default component.exports